import React from 'react';
import { Redirect, Route, Switch, useParams } from 'wouter';
import { Host } from '../../Host';
import { AllBoardsPage } from '../boards/AllBoardsPage';
import { EditorPage } from '../canvas/EditorPage';
import { KioskPage } from '../canvas/kiosk/KioskPage';
import { DemoPage } from '../dev/DemoPage';
import { DevPage } from '../dev/DevPage';
import { LegacyBoardsPage } from '../legacy/LegacyBoardsPage';
import { ManagementPage } from '../management/ManagementPage';
import { TutorialsPage } from '../onboarding/TutorialsPage';
import { BasicTutorialPage } from '../onboarding/tutorials/TutorialPage';
import { TemplateLibraryPage } from '../templateLibrary/TemplateLibraryPage';
import { WorkspacePage } from '../workspace/WorkspacePage';

const RedirectToCheckout = () => {
    const { page } = useParams<{ page: string }>();
    window.location.href = `${Host.baseUrl}/checkout/${page}`;
    return null;
};

const EntityRoute = () => {
    const { entityId } = useParams<{ entityId: string, param?: string }>();
    switch (entityId.slice(0, 2)) {
        case 'BO': return <EditorPage />;
        case 'WO': return <WorkspacePage />;
        case 'FO': return <WorkspacePage />;
        default: return <Redirect to="~/boards" />;
    }
};

const DefaultRoute = () => {
    return <Redirect to="~/boards" />;
};

export const AccountSwitch = () =>
    <Switch>
        <Route path="/board/:entityId">
            <Redirect to="/:entityId" />
        </Route>
        <Route path="/checkout/:page?">
            <RedirectToCheckout />
        </Route>
        <Route path="/recent">
            <Redirect to="/boards" />
        </Route>
        <Route path="/boards" component={AllBoardsPage} />
        <Route path="/dev" component={DevPage} />
        <Route path="/demo" component={DemoPage} />
        <Route path="/kiosk" component={KioskPage} />
        <Route path="/legacy" component={LegacyBoardsPage} />
        <Route path="/library/:group?" component={TemplateLibraryPage} />
        <Route path="/live" component={DefaultRoute} />
        <Route path="/manage/:section?/:param?" component={ManagementPage} />
        <Route path="/templates/:group?" component={TemplateLibraryPage} />
        <Route path="/tutorials" component={TutorialsPage} />
        <Route path="/:entityId" nest component={EntityRoute} />
        <Route path="/tutorials-participant" component={BasicTutorialPage} />
        <Route path="/tutorials-host" component={BasicTutorialPage} />
        <Route path="*" component={DefaultRoute} />
    </Switch>
    ;
